import 'whatwg-fetch';
import _ from 'lodash';
import { getAuthHeader, getPilotLoginUrl } from 'rawr/utils/auth';

const JSON_HEADERS = {
  'accept': 'application/json',
  'content-type': 'application/json'
};
const JSON_FILE_UPLOAD_HEADERS = {
    'accept': 'application/json'
    // There should be no content-type header set,as fetch adds it automatically based on body type
};

function method(name, isFileUpload = false) {
  return function(url, options = {}) {
    const opts = _.clone(options);
    if (!isFileUpload && typeof opts.body !== 'string') {
      opts.body = JSON.stringify(opts.body);
    }
    _.defaults(opts, {
      method: name,
      headers: isFileUpload? JSON_FILE_UPLOAD_HEADERS: JSON_HEADERS
    });
    return api(url, opts);
  };
}

function api(url, options={}) {
    if (!url.match(/^\W|(https?:)/)) {
        url = '/n/api/' + url;
    }
    options.headers = options.headers || JSON_HEADERS;

    // Need to skip this sometimes, e.g. when accessing S3 buckets.
    if (!options.noCORS) {
        const authHeader = getAuthHeader();
        if (!!authHeader.Authorization) {
          _.assign(options.headers, {Authorization: authHeader.Authorization});
        }
    }

    return fetch(url, options)
        .catch((err) => {
            if(err.status === 401) {
                // redirect to account-service
                window.location.href = getPilotLoginUrl();
            }
            Promise.reject('Network Error');
        })
        .then(function(resp) {
            if (resp) {
                if (options.method === 'HEAD') {
                    // For HEAD requests, just send along the status.
                    return Promise.resolve(resp.status);
                }
                if (resp.status >= 200 && resp.status < 300) {
                    if (resp.status === 204) {
                        return Promise.resolve(null);
                    } else if (resp.headers.get('content-type').includes('application/json')) {
                        return Promise.resolve(resp.json());
                    } else {
                        return Promise.resolve(resp.text());
                    }
                } else if (resp.headers.get('content-type') === 'application/json') {
                    return resp.json().then(function(json) {
                        return Promise.reject(json.message || resp.statusText);
                    });
                } else {
                    return Promise.reject(resp.statusText);
                }
            } else {
                return Promise.reject('Network Error');
            }
        });
}

api.get = method('GET');
api.post = method('POST');
api.postFile = method('POST', true);
api.put = method('PUT');
api.patch = method('PATCH');
api.delete = method('DELETE');
api.head = method('HEAD');

export default api;



/** WEBPACK FOOTER **
 ** core/client/rawr/api/index.js
 **/